import HistoricList from "@/components/Shared/HistoricList.vue"
import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';
import cloneDeep from 'lodash/cloneDeep';
import SolutionsServices from '@/services/firebase/SolutionsServices/SolutionsServices';
import SolutionsGroup from '@/services/firebase/SolutionsGroup/SolutionsGroup';
import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import InputMoney from "@/components/Forms/Input/input-money.vue";
import NumberInput from "../../../../Inputs/NumberInput.vue";
import RichTextEditor from '@/components/formatter/RichTextEditor.vue'
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
export default {
    name: "ProposalTab",

    components: {
        RichTextEditor,
        HistoricList,
        InputMoney,
        NumberInput
    },

    props: {
        desiredProposal: {
            type: Array,
            default: []
        },
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Object,
            default: () => ({})
        },
    },

    data: () => ({
        proposalList: [],
        diagnostic: {},
        projectSolutions: [],
        is_loading: false,
        modal: false,
        serviceModal: false,
        productModal: false,
        columnVisibility: {
            solution: true,
            group: true,
            quantity: true,
            unitPrice: true,
            total: true,
            totalInvestment: true
        },

        solutionList: [],

        solutions: [],
        items: [],
        typeProposal: {
            defaultPrice: 600.99,

            number_water_start:null,
            number_water_target:null,
            number_water_360:0,
            number_reservation:0,

            reservation_plan: 199.90,
            managementPlan: null,
            paybackMin: 50,
            paybackMax: 30,

            water_start_plan: 199.90,
            water_target_plan: 374.90,
            water_360_plan: 99.90,
            water_start_plan_month_additional_spot: 139.90,
            water_target_plan_month_additional_spot: 259.90,
            water_360_plan_month_additional_spot: 449.90,

            water_start_plan_yearly: 149.90,
            water_target_plan_yearly: 299.90,
            water_360_plan_yearly: 499.90,
            water_start_plan_yearly_additional_spot: 99.90,
            water_target_plan_yearly_additional_spot: 149.90,
            water_360_plan_yearly_additional_spot: 249.90,
            isFranchise: false,
            obs: '',
        },
        item: {
            unitPrice: 0,
            amount: 0,
            total: 0,
        },
        listSolutions: [],
        listServices: [],
        listProducts: [],
        allSolutions: [],
        groupsData: [],
        isValidForm: false,
        usedProposalTypes: [],
        options: [
            { text: "Modelo Performance", value: "model_performance", disabled: false },
            { text: "Venda do Projeto", value: "investment", disabled: false },
            { text: "Pré-Fixado", value: "pre_fixed", disabled: false },
            { text: "Gestão", value: "management", disabled: false }
          ],
          headersInsatallations:[
            { text: "Solução", value: "solution" },
            { text: "Observação", value: "description" },
          ],
        headersSolutions: [
            { text: "Solução", value: "solution" },
            { text: "R$ Unidade", value: "unitPrice" },
            { text: "Qntd.", value: "amount" },
            { text: "Total", value: "total" },
            { text: "Ações ", value: "actions", align: "end" },
        ],
        headersService: [
            { text: "Serviços", value: "serviceName" },
            { text: "R$ Unidade", value: "unitPrice" },
            { text: "Qntd.", value: "amount" },
            { text: "Total", value: "total" },
            { text: "Ações ", value: "actions", align: "end" },
        ],
        headersProduct: [
            { text: "Produtos", value: "productName" },
            { text: "R$ Unidade", value: "unitPrice" },
            { text: "Qntd.", value: "amount" },
            { text: "Total", value: "total" },
            { text: "Ações ", value: "actions", align: "end" },
        ],
        editProposalId: null,
        indexEdit: -1, 
        revision: { status: null },
        requiredRule: v => (v !== null ? true : 'Por favor, selecione uma opção.'),
        rulesRange: v => (v && v >= 0 && v <= 100) || 'O valor deve estar entre 0 e 100.',
        daysToAdd: 30,
        displayHydrometerMode: 'installation',
        displayReservoirMode: 'installation',
    }),

    computed: {
        rulesRequired() {
            return Rules.required()
        },
        rulesDiscountMonetary() {
            return [
                ...this.rulesRequired,
                (v) => {
                    if (!v && v !== 0) return 'Desconto é obrigatório';
                    const discountValue = parseFloat(v) || 0;
                    const totalValue = parseFloat(this.sumValueTotal) || 0;
                    if (discountValue > totalValue) {
                        return `Desconto não pode ser maior que o valor total (R$ ${this.currencyFormat(totalValue)})`;
                    }
                    if (discountValue < 0) {
                        return 'Desconto não pode ser negativo';
                    }
                    return true;
                }
            ];
        },
        rulesDiscountPercentage() {
            return [
                ...this.rulesRequired,
                (v) => {
                    if (!v && v !== 0) return 'Desconto é obrigatório';
                    const discountValue = parseFloat(v) || 0;
                    if (discountValue > 100) {
                        return 'Desconto não pode ser maior que 100%';
                    }
                    if (discountValue < 0) {
                        return 'Desconto não pode ser negativo';
                    }
                    return true;
                }
            ];
        },
        serviceList() {
            let data = this.allSolutions.filter(({ type }) => type === "Serviço")
            data.sort(this.orderSolution)
            return data
        },
        productList() {
            let data = this.allSolutions.filter(({ type }) => type === "Produto")
            data.sort(this.orderSolution)
            return data
        },
        sumValueTotal() {
            const lists = [
                ...this.listSolutions.filter(item => item.selected),
                ...this.listServices.filter(item => item.selected),
                ...this.listProducts.filter(item => item.selected)
            ];
            return lists.reduce((subTotal, item) => subTotal + Number(item.total), 0).toFixed(2);
        },
        discountTotal() {
            const { discountType, discountValue } = this.typeProposal;
            const totalValue = parseFloat(this.sumValueTotal) || 0;
            const discount = parseFloat(discountValue) || 0;
        
            if (discountType === "monetary") {
                return (totalValue - discount).toFixed(2);
            } else if (discountType === "percentage") {
                return (totalValue - (discount / 100) * totalValue).toFixed(2);
            }
        
            return totalValue.toFixed(2);
        },
        getAccountReference() {
            if (this.diagnostic && this.diagnostic.historics && Array.isArray(this.diagnostic.historics) && this.diagnostic.historics.length > 0) {
                // Filtra apenas itens com accountAmount válido (não null, não undefined, não NaN)
                const validHistorics = this.diagnostic.historics.filter(item => {
                    const amount = Number(item.accountAmount);
                    return !isNaN(amount) && amount > 0;
                });
                
                if (validHistorics.length === 0) {
                    return 0;
                }
                
                const totalConsumption = validHistorics.reduce((sum, item) => sum + Number(item.accountAmount), 0);
                return (totalConsumption / validHistorics.length);
            }
            return 0;
        },
        getPayback() {
            const accountReference = this.getAccountReference;
            
            // Verifica se há referência de conta válida
            if (!accountReference || accountReference === 0) {
                return `Dados Insuficientes`;
            }
            
            const reference = accountReference * 12;
            const selectedProducts = this.listProducts.filter(item => item.selected);
            const selectedServices = this.listServices.filter(item => item.selected);
            const selectedSolutions = this.listSolutions.filter(item => item.selected);
            
            const totalInvestment = parseFloat(this.resolveTotalInvestment(selectedProducts, selectedServices, selectedSolutions));
            
            // Verifica se há investimento válido
            if (!totalInvestment || totalInvestment === 0 || isNaN(totalInvestment)) {
                return `Dados Insuficientes`;
            }
            
            // Verifica se paybackMax e paybackMin são válidos
            // Nota: paybackMax armazena "Economia Min" e paybackMin armazena "Economia Max" (nomenclatura invertida)
            const economyMinValue = Number(this.typeProposal.paybackMax); // Economia mínima
            const economyMaxValue = Number(this.typeProposal.paybackMin); // Economia máxima
            
            if (isNaN(economyMinValue) || isNaN(economyMaxValue) || economyMinValue <= 0 || economyMaxValue <= 0) {
                return `Dados Insuficientes`;
            }
            
            const economyMax = economyMaxValue / 100; // Maior economia = menor payback
            const economyMin = economyMinValue / 100; // Menor economia = maior payback

            const calculatePayback = (economy) => {
                if (economy === 0 || reference === 0) {
                    return Infinity;
                }
                return totalInvestment / ((reference * economy) / 12);
            };

            const paybackMax = calculatePayback(economyMax);
            const paybackMin = calculatePayback(economyMin);
            
            if (this.typeProposal.type === 'model_performance') {
                return `Retorno Imediato`;
            }
            
            if (paybackMax === Infinity || paybackMax === 0 || paybackMin === Infinity || paybackMin === 0) {
                return `Retorno Imediato`;
            }
            
            if (isNaN(paybackMax) || isNaN(paybackMin)) {
                return `Dados Insuficientes`;
            }
            
            return `Entre ${paybackMin.toFixed(0)} e ${paybackMax.toFixed(0)} meses`;
        },
        hydrometerSolutionsFormatted() {
            if (!this.param || !this.param.hydrometerList) return [];
            const filteredList = this.param.hydrometerList.filter(item => {
                if (this.displayHydrometerMode === 'installation') {
                    return item.ifInstallation;
                } else if (this.displayHydrometerMode === 'loan') {
                    return item.ifLoan;
                }
                return false; // Default case, should not happen with current modes
            });

            return filteredList.map(item => ({
                solution: item.model || 'Hidrômetro', 
                description: item.comments || "", 
            }));
        },
        reservoirSolutionsFormatted() {
            if (!this.param || !this.param.reservoirList) return [];

            const filteredList = this.param.reservoirList.filter(item => {
                if (this.displayReservoirMode === 'installation') {
                    return item.ifInstallation;
                } else if (this.displayReservoirMode === 'loan') {
                    return item.ifLoan;
                }
                return false; // Default case, should not happen with current modes
            });

            return filteredList.map(item => ({
                solution: item.type || 'Sensor', 
                description: item.comments || "", 
            }));
        },
    },

    methods: {
        applyProposalTypeAvailability(usedTypesParam) {
            const usedTypes = Array.isArray(usedTypesParam) ? usedTypesParam : this.usedProposalTypes || [];
            const currentType = this.typeProposal && this.typeProposal.type ? this.typeProposal.type : null;
            const allowedFromProspection = new Set(
                (this.desiredProposal || []).map((t) => (typeof t === 'string' ? t : (t && t.value)))
            );

            this.options = this.options.map((option) => {
                const notSelectedInProspection = allowedFromProspection.size > 0 ? !allowedFromProspection.has(option.value) : false;
                const alreadyUsed = usedTypes.includes(option.value);
                const isCurrent = option.value === currentType;
                return {
                    ...option,
                    disabled: (notSelectedInProspection || alreadyUsed) && !isCurrent,
                };
            });
        },
        resolveTotalInvestment(listProducts, listServices, listSolutions) {
            const calculateTotal = (list) => {
                return list.reduce((acc, item) => acc + (item.total || 0), 0);
            };

            const totalProducts = calculateTotal(listProducts || []);
            const totalServices = calculateTotal(listServices || []);
            const totalSolutions = calculateTotal(listSolutions || []);

            const grandTotal = totalProducts + totalServices + totalSolutions;

            if (this.typeProposal.hasDiscount) {
                let discountValue = parseFloat(this.typeProposal.discountValue) || 0;

                if (this.typeProposal.discountType === 'percentage') {
                    const discountAmount = (grandTotal * discountValue) / 100;
                    return parseFloat((grandTotal - discountAmount).toFixed(2));
                } else if (this.typeProposal.discountType === 'monetary') {
                    return parseFloat((grandTotal - discountValue).toFixed(2));
                }
            }

            return parseFloat(grandTotal.toFixed(2));
        },
        formatCurrencyValue(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value);
        },
        selectedProposal(proposal) {
            if (proposal) {
                this.editProposalId = proposal.id_doc
              
                this.typeProposal = {
                    ...proposal.typeProposal,
                    isFranchise: proposal.typeProposal && typeof proposal.typeProposal.isFranchise !== 'undefined' ? proposal.typeProposal.isFranchise : false,
                    obs: proposal.typeProposal?.obs || '',
                }

                // Faz merge completo dos dados salvos da proposta, preservando preços editados
                this.listSolutions = this.listSolutions.map(item => {
                    const found = proposal.listSolutions.find(p => p.solutionId === item.solutionId);
                    if (found) {
                        // Preserva os preços editados (unitPrice) da proposta salva
                        // Mantém a quantidade atualizada do checklist (item.amount)
                        // Recalcula o total baseado no preço preservado e quantidade atualizada
                        const preservedUnitPrice = found.unitPrice !== undefined ? found.unitPrice : item.unitPrice;
                        const updatedAmount = item.amount; // Quantidade atualizada do checklist
                        const recalculatedTotal = Number((preservedUnitPrice * updatedAmount).toFixed(2));
                        
                        return {
                            ...item,
                            unitPrice: preservedUnitPrice, // Preserva preço editado
                            amount: updatedAmount, // Mantém quantidade atualizada do checklist
                            total: recalculatedTotal, // Recalcula total com quantidade atualizada
                            selected: found.selected !== undefined ? found.selected : true
                        };
                    } else {
                        // Se não encontrou na proposta, mantém o item original mas atualiza selected
                        return {
                            ...item,
                            selected: item.selected !== undefined ? item.selected : true
                        };
                    }
                });

                this.listServices = (proposal.listServices || []).map(item => ({
                    ...item,
                    selected: item.selected !== undefined ? item.selected : true
                }));

                this.listProducts = (proposal.listProducts || []).map(item => ({
                    ...item,
                    selected: item.selected !== undefined ? item.selected : true
                }));

                this.revision = proposal.revision
                this.columnVisibility = {
                    solution: proposal.columnVisibility?.solution ?? true,
                    group: proposal.columnVisibility?.group ?? true,
                    quantity: proposal.columnVisibility?.quantity ?? true,
                    unitPrice: proposal.columnVisibility?.unitPrice ?? true,
                    total: proposal.columnVisibility?.total ?? true,
                    totalInvestment: proposal.columnVisibility?.totalInvestment !== undefined ? proposal.columnVisibility.totalInvestment : true
                }
            } else {
                this.editProposalId = null
                this.typeProposal = {}
                this.listServices = []
                this.listProducts = []
                this.revision = {}
                this.columnVisibility = {
                    solution: true,
                    group: true,
                    quantity: true,
                    unitPrice: true,
                    total: true,
                    totalInvestment: true
                }
                // Recarrega as soluções com preços originais quando a proposta é desmarcada
                this.getSolutions()
            }
        },
        selectUnitPrice(solution) {
            const selectedSolution = this.allSolutions.find(({ id }) => id === solution)
            this.item.unitPrice = selectedSolution.price
        },
        orderSolution(itemA, itemB) {
            let solutionNameA = ((itemA.group ? itemA.group : '') + (itemA.solutionCod ? itemA.solutionCod : ''))
            let solutionNameB = ((itemB.group ? itemB.group : '') + (itemB.solutionCod ? itemB.solutionCod : ''))
            if (solutionNameA > solutionNameB) {
                return 1
            } else if (solutionNameA < solutionNameB) {
                return -1
            } else {
                return 0
            }
        },
        clearItem() {
            this.item = {
                unitPrice: 0,
                amount: 0,
                total: 0,
            }
            this.indexEdit = -1
            this.modal = false
            this.serviceModal = false
            this.productModal = false
        },
        async addNewItemSolution() {
            this.mode = 'create'
            this.serviceModal = true
        },
        async addNewItemProduct() {
            this.mode = 'create'
            this.productModal = true
        },
        async saveItem() {
            Object.keys(this.listSolutions[this.indexEdit]).forEach(
                (key) => {
                    this.$set(this.listSolutions[this.indexEdit], key, this.item[key])
                }
            )
            this.clearItem()
        },
        async saveItemService() {
            delete this.item.product 
            const selectedSolution = this.allSolutions.find(({ id }) => id === this.item.service)
            if (this.mode === "create") {
                this.listServices.push({
                    ...this.item,
                    serviceName: selectedSolution.solution,
                    selected: true,
                })
            } else {
                this.item = {
                    ...this.item,
                    total: (this.item.unitPrice * this.item.amount),
                    serviceName: selectedSolution.solution
                }
                Object.keys(this.listServices[this.indexEdit]).forEach(
                    (key) => {
                        this.$set(this.listServices[this.indexEdit], key, this.item[key])
                    }
                )
            }
            this.clearItem()
        },
        async saveItemProduct() {
            const selectedSolution = this.allSolutions.find(({ id }) => id === this.item.product)
            if (this.mode === "create") {
                this.listProducts.push({
                    ...this.item,
                    productName: selectedSolution.solution,
                    selected: true,
                })
            } else {
                this.item = {
                    ...this.item,
                    total: (this.item.unitPrice * this.item.amount),
                    productName: selectedSolution.solution
                }

                Object.keys(this.listProducts[this.indexEdit]).forEach(
                    (key) => {
                        this.$set(this.listProducts[this.indexEdit], key, this.item[key])
                    }
                )
            }
            this.clearItem()
        },
        async editItem(item) {
            this.mode = 'edit'
            this.indexEdit = this.listSolutions.findIndex(prod => prod === item)
            this.item = cloneDeep(this.listSolutions[this.indexEdit])
            this.modal = true
        },
        async editItemService(item) {
            this.mode = 'edit'
            this.indexEdit = this.listServices.findIndex(prod => prod === item)
            this.item = cloneDeep(this.listServices[this.indexEdit])
            this.serviceModal = true
        },
        async editItemProduct(item) {
            this.mode = 'edit'
            this.indexEdit = this.listProducts.findIndex(prod => prod === item)
            this.item = cloneDeep(this.listProducts[this.indexEdit])
            this.productModal = true
        },
        async deleteItemProduct(item) {
            this.listProducts = this.listProducts.filter((prod) => prod !== item)
            this.clearItem()
        },
        async deleteItemService(item) {
            this.listServices = this.listServices.filter((prod) => prod !== item)
            this.clearItem()
        },
        async getSolutions() {
            
            if (!this.projectSolutions ) return
            this.projectSolutions = this.projectSolutions.filter(item => item.isDeleted !== true)
            const listSearchSolution = this.projectSolutions.map(({ solution }) => solution)

            const countSolutions = (arr) => {
                return arr.reduce((acc, obj) => {
                    const solution = obj.solution;
                    const baseAmount = Number(obj.amountSolution) || 0;
                    // Multiplicador de unidades por local vindo do checklist (localTotalUnits).
                    // Se não existir (diagnósticos antigos), assume 1.
                    const localUnits = Number(obj.localTotalUnits || 1) || 1;
                    const amount = baseAmount * localUnits;
                    acc[solution] = (acc[solution] || 0) + amount;
                    return acc;
                }, {});
            };
            const sumSolutions = countSolutions(this.projectSolutions)
            let response = await SolutionsServices.GetSolutionsByIds(listSearchSolution)
            
            // Cria a lista base com preços padrão
            const baseListSolutions = Object.values(response).map((solution) => ({
                amount: sumSolutions[solution.id],
                solution: solution.solution,
                solutionId: solution.id,
                total: Number((sumSolutions[solution.id] * Number(solution.price)).toFixed(2)),
                unitPrice: Number(Number(solution.price).toFixed(2)),
                selected: true,
            }))
            
            // Se já existe uma proposta carregada, faz merge preservando preços editados
            if (this.editProposalId && this.proposalList && this.proposalList.length > 0) {
                const currentProposal = this.proposalList.find(p => p.id_doc === this.editProposalId);
                if (currentProposal && currentProposal.listSolutions) {
                    // Faz merge: usa preços editados da proposta quando existirem, senão usa preços padrão
                    this.listSolutions = baseListSolutions.map(baseItem => {
                        const savedItem = currentProposal.listSolutions.find(p => p.solutionId === baseItem.solutionId);
                        if (savedItem) {
                            // Preserva preços editados da proposta salva
                            // Mantém a quantidade atualizada do checklist (baseItem.amount)
                            // Recalcula total baseado no preço preservado e quantidade atualizada
                            const preservedUnitPrice = savedItem.unitPrice !== undefined ? savedItem.unitPrice : baseItem.unitPrice;
                            const updatedAmount = baseItem.amount; // Quantidade atualizada do checklist
                            const recalculatedTotal = Number((preservedUnitPrice * updatedAmount).toFixed(2));
                            
                            return {
                                ...baseItem,
                                unitPrice: preservedUnitPrice, // Preserva preço editado
                                amount: updatedAmount, // Mantém quantidade atualizada do checklist
                                total: recalculatedTotal, // Recalcula total com quantidade atualizada
                                selected: savedItem.selected !== undefined ? savedItem.selected : baseItem.selected
                            };
                        }
                        return baseItem;
                    });
                    return;
                }
            }
            
            // Se não há proposta carregada, usa a lista base
            this.listSolutions = baseListSolutions;
        },
        currencyFormat(value) {
            return Utils.formatCurrency(value)
        },
        convertGroupNamePerSolution(solutionId) {
            const solutionFilter = this.allSolutions.filter(({ id }) => id == solutionId)
            if (solutionFilter.length) {
                const groupFilter = this.groupsData.filter(({ id }) => id == solutionFilter[0].groupId)
                return groupFilter.length > 0 ? groupFilter[0].name : "Não Existe"
            }
            return "Não Existe"
        },
        async saveProposal() {
            if (this.$refs.typeProposalData && !this.$refs.typeProposalData.validate()) throw new Error("Preencha todos os campos!")

            // Validação de desconto
            if (this.typeProposal.hasDiscount && this.typeProposal.discountValue) {
                const discountValue = parseFloat(this.typeProposal.discountValue) || 0;
                const totalValue = parseFloat(this.sumValueTotal) || 0;
                
                if (this.typeProposal.discountType === 'monetary') {
                    if (discountValue > totalValue) {
                        showErrorSnackBar(`Desconto não pode ser maior que o valor total da proposta (R$ ${this.currencyFormat(totalValue)})`);
                        return;
                    }
                    if (discountValue < 0) {
                        showErrorSnackBar('Desconto não pode ser negativo');
                        return;
                    }
                } else if (this.typeProposal.discountType === 'percentage') {
                    if (discountValue > 100) {
                        showErrorSnackBar('Desconto percentual não pode ser maior que 100%');
                        return;
                    }
                    if (discountValue < 0) {
                        showErrorSnackBar('Desconto não pode ser negativo');
                        return;
                    }
                }
            }

            const checkExistProposalType = this.proposalList.find(({typeProposal})=> typeProposal.type === this.typeProposal.type)

            if(checkExistProposalType && !this.editProposalId) {
                showErrorSnackBar(`Ja existe uma proposta desse tipo ${this.options.find(({value})=> value === this.typeProposal.type).text}`)
                return
            }
            const proposal = {
                id_diagnostic: this.diagnostic.id_doc,
                typeProposal: this.typeProposal,
                listSolutions: this.listSolutions,
                listServices: this.listServices,
                listProducts: this.listProducts,
                createdAt: new Date(),
                revision: this.revision,
                columnVisibility: this.columnVisibility || {
                    solution: true,
                    group: true,
                    quantity: true,
                    unitPrice: true,
                    total: true,
                    totalInvestment: true
                }
            }

            if(this.editProposalId){
                await DiagnosticProposalService.editWaterScanProposal(this.editProposalId,{...proposal, id_doc: this.editProposalId})
            }else{
                await DiagnosticProposalService.createDiagnostic(proposal)
            }
        },
        async getProposalList(idDiagnostic) {

            const status = {
                approved: "Aprovado",
                revision: "Revisão",
                reproved: "Reprovado",
                outdated: "Desatualizado"
            }

            if(idDiagnostic){
                this.proposalList = await DiagnosticProposalService.getWaterScanProposalByDiagnosticId(idDiagnostic)

                const usedTypes = this.proposalList.map(proposal => proposal.typeProposal.type);
                this.usedProposalTypes = usedTypes;

                // Recompute availability considering used types and prospection selection
                this.applyProposalTypeAvailability(usedTypes);

                this.proposalList = this.proposalList.map((proposal) => ({
                    ...proposal,
                    name: `${this.options.find((model) => model.value === proposal.typeProposal.type).text} / ${Utils.formatDateDayJs(new Date(proposal.createdAt.seconds * 1000), "DD-MM-YYYY [,] HH:mm")} / ${status[proposal.revision.status]}`
                }));
            }
                
        },
        getColumnVisibility() {
            return this.columnVisibility;
        },
        setColumnVisibility(visibility) {
            this.columnVisibility = {
                ...this.columnVisibility,
                ...visibility
            };
        },
        getColumnVisibilityWithDefaults(proposal) {
            if (!proposal || !proposal.columnVisibility) {
                return {
                    solution: true,
                    group: true,
                    quantity: true,
                    unitPrice: true,
                    total: true,
                    totalInvestment: true
                }
            }
            return {
                solution: proposal.columnVisibility.solution ?? true,
                group: proposal.columnVisibility.group ?? true,
                quantity: proposal.columnVisibility.quantity ?? true,
                unitPrice: proposal.columnVisibility.unitPrice ?? true,
                total: proposal.columnVisibility.total ?? true,
                totalInvestment: proposal.columnVisibility.totalInvestment !== undefined ? proposal.columnVisibility.totalInvestment : true
            }
        },
        async updateExpireDate(){
            try {
                let expired = new Date();
                expired.setDate(expired.getDate() + this.daysToAdd);
                await DiagnosticProposalService.editWaterScanProposal(this.editProposalId, { expiredAt: expired });
                showSuccessSnackBar("Data atualizada com sucesso")
            } catch (error) {
                console.error('Error updating expire dates:', error);
                showErrorSnackBar("Erro ao atualizar datas de expiração");
            }
        },
        updateProviderPercentage() {
            if (this.typeProposal.isFranchise) {
                let total = Number(this.typeProposal.client_percentage || 0) + Number(this.typeProposal.franchise_percentage || 0);
                this.typeProposal.provider_percentage = total > 100 ? 0 : 100 - total;
            } else {
                this.typeProposal.provider_percentage = 100 - Number(this.typeProposal.client_percentage || 0);
            }
        },
    },
    async created() {
        this.groupsData = await SolutionsGroup.getSolutionsGroup()
        this.allSolutions = await SolutionsServices.GetSolutions()

        const proposalType = this.typeProposal.type;

        // Initially apply availability using current selection and any prospection constraints
        this.applyProposalTypeAvailability();

    },
    watch: {
        show: {
            immediate: true,
            handler: async function (newValue)  {
                if (newValue && this.param) {
                    this.diagnostic = this.param
                    await this.getProposalList(this.param.id_doc)
                    this.projectSolutions = cloneDeep(this.param.solutionList)
                    this.getSolutions()
                }
            }
        },
        desiredProposal: {
            handler() {
                // Re-apply option availability whenever prospection selection changes
                this.applyProposalTypeAvailability();
            },
            deep: true
        },
        'item.amount': function (newVal) {
            if (newVal !== null) {
                this.item.total = this.item.unitPrice * newVal
            }
        },
        'item.unitPrice': function (newVal) {
            if (newVal !== null) {
                this.item.total = this.item.amount * newVal
            }
        },
        'typeProposal.franchise_percentage': function (newVal) {
            if (newVal !== null) {
                this.updateProviderPercentage();
            }
        },
        'typeProposal.client_percentage': function (newVal) {
            if (newVal !== null) {
                this.updateProviderPercentage();
            }
        },
        'typeProposal.isFranchise': function(newVal){ 
            this.updateProviderPercentage()
        }
    },

};